// SelectedNodeInfo.jsx
import React from 'react';

const SelectedNodeInfo = ({ node }) => {
  const defaultNode = {
    name: "Select a node",
    definition: "Click on a node in the knowledge graph to view details",
    evidence: {},
    treatments: []
  };

  const nodeData = node || defaultNode;

  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-2">Selected Node:</h2>
     
      <h3 className="text-xl font-medium text-gray-800 mb-4">{nodeData.name}</h3>
     
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Definition:</h4>
        <p className="text-gray-800">
          {nodeData.definition}
        </p>
      </div>
     
      {nodeData.evidence && Object.keys(nodeData.evidence).length > 0 && (
        <div className="mb-4">
          <h4 className="font-medium text-gray-700 mb-1">Related Evidence:</h4>
          <ul className="space-y-1">
            {nodeData.evidence.trials && (
              <li className="text-gray-700 flex items-start">
                <span className="mr-1">•</span> {nodeData.evidence.trials} clinical trials
              </li>
            )}
            {nodeData.evidence.papers && (
              <li className="text-gray-700 flex items-start">
                <span className="mr-1">•</span> {nodeData.evidence.papers} research papers
              </li>
            )}
            {nodeData.evidence.guidelines && (
              <li className="text-gray-700 flex items-start">
                <span className="mr-1">•</span> {nodeData.evidence.guidelines} treatment guidelines
              </li>
            )}
          </ul>
        </div>
      )}
     
      {nodeData.treatments && nodeData.treatments.length > 0 && (
        <div>
          <h4 className="font-medium text-gray-700 mb-1">Connected Treatments:</h4>
          <ul className="space-y-1">
            {nodeData.treatments.map((treatment, index) => (
              <li key={index} className="text-gray-700 flex items-start">
                <span className="mr-1">•</span> {treatment}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SelectedNodeInfo;